import i18n from '../i18n';
import { apiFetch } from './apiClient';

// Generic helper function to initiate a process
const initiateProcess = async (processType, noteContent, additionalInformation, sessionId = null, documentLanguage) => {
  try {
    const response = await apiFetch('/api/process-functions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Ensures cookies are sent with the request
      body: JSON.stringify({
        process_type: processType,
        noteContent,
        additionalInformation,
        sessionId,
        ...(documentLanguage ? { document_language: documentLanguage } : {}),
      }),
    });

    if (!response.ok) {
      throw new Error(i18n.t('process.error'));
    }

    return await response.json();
  } catch (error) {
    console.error(`Error processing ${processType}:`, error);
    throw error;
  }
};

// Function to initiate a Treatment-Plan Letter process
export const initiateTreatmentPlanLetter = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('treatment-plan-letter', noteContent, additionalInformation, sessionId, documentLanguage);

// Function to initiate a Consultation Letter process
export const initiateConsultationLetter = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('consultation-letter', noteContent, additionalInformation, sessionId, documentLanguage);

// Function to initiate a Referral Letter process
export const initiateReferralLetter = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('referral-letter', noteContent, additionalInformation, sessionId, documentLanguage);

// Function to initiate a SOAP Note process
export const initiateSoapNote = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('soap-note', noteContent, additionalInformation, sessionId, documentLanguage);

// Function to initiate a Discharge Summary process
export const initiateDischargeSummary = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('discharge-summary', noteContent, additionalInformation, sessionId, documentLanguage);

// Function to initiate a Specialty-Specific Template process
export const initiateSpecialtyTemplate = (noteContent, additionalInformation, sessionId = null, documentLanguage) =>
  initiateProcess('specialty-template', noteContent, additionalInformation, sessionId, documentLanguage);
